/* eslint-disable max-len */
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { Copy, Title } from '../dashboard/elements/LayoutElements';
import { Colors, Menu } from './../../ui';
import { ConnectionsView } from './ConnectionsView';
import { ControlsView } from './ControlsView';
import { useLeaveFormGuard } from './FormBoundary';
import { NotificationsView } from './NotificationsView';
import { PersonalizationView } from './PersonalizationView';
import { ProfileView } from './ProfileView';
import { PromptsView } from './PromptsView';
import { TeamView } from './TeamView';

const Frame = styled.div`
    display: grid;
    grid-template-columns: 12rem auto;
    max-width: 64rem;
    min-height: 100%;
    margin: 0 auto;
`;

const Left = styled.div`
    padding-top: 5rem;
    padding-right: .25rem;
    border-right: solid .0675rem ${Colors.border};
    background: linear-gradient(90deg, rgba(255,255,255,1) 0%, hsl(0deg 0% 97%) 100%);
`;

const MenuItem = styled<any>(Menu.Item)`
    margin-bottom: .25rem !important;
    color: ${Colors.text} !important;
    border-radius: .25rem !important;

    ${p => p.active ? css`
        background: ${Colors.hover} ;
    ` : ''}
`;

const Main = styled.div`
    padding-left: 3rem;

    ${Title}, ${Copy} {
        color: ${Colors.text};
    }
`;

const MainTitle = styled(Title)`
    padding: 1rem 0;
    margin-top: .75rem;
    font-size: 1.5rem;
`;

const opt = (id: string, label: string, ui: any) => ({ id, label, ui });
const options = [
    opt('profile', 'User Profile', ProfileView),
    opt('connections', 'Connections', ConnectionsView),
    opt('controls', 'Controls & UI', ControlsView),
    opt('personalization', 'Personalization', PersonalizationView),
    opt('prompts', 'Prompts & Popups', PromptsView),
    opt('notifications', 'Notifications', NotificationsView),
    opt('team', 'Your Org', TeamView),
];

export const PreferencesLayout = ({ initialOption }: { initialOption?: string }) => {

    const account = useResolve(AccountModel);

    // This sux, but it's a quick fix for now
    let opts = options;
    if (!account.plan.features.jiraBeta) {
        opts = options.filter(x => x.id !== 'connections');
    }

    const [active, setActive] = useState(opts.find(x => x.id === initialOption) ?? opts[0]);
    const guardedSetActive = useLeaveFormGuard(setActive);

    return <Frame>
        <Left>
            <Menu>
                {opts.map(o =>
                    <MenuItem key={o.id} active={active === o} onClick={() => guardedSetActive(o)}>
                        {o.label}
                    </MenuItem>
                )}
            </Menu>
        </Left>
        <Main>
            {active && <>
                <MainTitle>{active.label}</MainTitle>
                {React.createElement(active.ui)}
            </>}
        </Main>
    </Frame>;
};
